import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { utils, writeFile } from 'xlsx';
import { useGlobalContext } from '../../../../Contexts/GlobalContext';
import { BASE_URL, CustomTablePagination } from '../../../../Utlils';
import { getStatsDetail } from './helperData';
import TableLoader from './TableLoader';
import NoData from '../../../../components/NoData';
import { useQuery } from '@tanstack/react-query';
import { Tooltip } from '../../../../components/UiComponents/Ui';
import SelectSuppliers from '../../components/SelectSurveySuppliers';
import ConfirmationModal from '../../../../components/UiComponents/ConfirmationModal.jsx';
import { convertSessionsToComplete } from '../../surveyActions';

let dummyfilterData = [
  { label: 'All', value: 'all' },
  { label: 'Completes', value: '10' },
  { label: 'Over Quota', value: '40' },
  { label: 'Prescreens', value: '1' },
  { label: 'Security Drops', value: [36, 30, 38, 35] },
  { label: 'Terminates', value: [20, 30] },
];

const CONVERTIBLE_TABS = [2, 3, 5];

const RespondentAnswers = ({ data, qualificationTable }) => {
  const { setSnackbar, organization, user } = useGlobalContext();
  const { id } = useParams();
  const [tab, setTab] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showConvertModal, setShowConvertModal] = useState(false);
  const [converting, setConverting] = useState(false);
  const [filters, setFilters] = useState({
    startDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 3,
      new Date().getDate(),
    )?.toLocaleDateString('en-CA'),

    endDate: new Date().toLocaleDateString('en-CA'),
    suppliers: [],
  });
  const [tempFilters, setTempFilters] = useState(filters);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);

  //GET SURVEY SESSIONS:
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const {
    data: surveySessions,
    isLoading,
    isError,
    refetch: refetchSurveySessions,
  } = useQuery({
    queryFn: () => getSurveySessions(),
    queryKey: [
      `${id}-respondentAnswers-${filters?.startDate}-${filters?.endDate}-${tab}-${page}-${rowsPerPage}`,
      filters?.suppliers?.map((item) => item?.value)?.join(',') || '',
    ],
    staleTime: 10000,
    cacheTime: 15000,
  });

  const getSurveySessions = async () => {
    try {
      const sessionData = await axios.get(
        `${BASE_URL}/session/get-survey-sessions?surveyID=${id}&startDate=${
          filters.startDate
        }&endDate=${filters.endDate}&tab=${tab}&page=${
          Number(page) + 1
        }&rows=${rowsPerPage}&suppliers=${filters?.suppliers?.map((item) => item?.value)?.join(',') || ''}`,
      );
      return sessionData?.data;
    } catch (error) {
      // console.log(error);
      return error;
    }
  };
  // console.log(tab);

  //DOWNLOAD TO EXCEL:
  const DownloadToExcel = () => {
    var elt = document.getElementById('table-to-xls-DATA');
    var wb = utils.table_to_book(elt, { sheet: 'MiratsQuanto' });
    const worksheet = wb.Sheets[wb.SheetNames[0]];
    const jsonData = utils.sheet_to_json(worksheet);
    const filteredData = jsonData.map((row) => {
      delete row.Select;
      return row;
    });
    const newWorksheet = utils.json_to_sheet(filteredData);
    const newWorkbook = utils.book_new();
    utils.book_append_sheet(newWorkbook, newWorksheet, 'MiratsQuanto');
    writeFile(
      newWorkbook,
      `Mirats Quanto - SN#${data?.surveyNumber}${filters?.suppliers?.length ? ` - ${filters?.suppliers?.map((item) => item?.label)?.join(', ')}` : ''} - Resp Answers.xlsx`,
    );
    setSnackbar({
      open: true,
      severity: 'success',
      msg: 'Excel Sheet Downloaded!',
    });
  };

  // pagination function
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const refetchSurveySessionsData = (start, end) => {
    setFilters({ startDate: start, endDate: end });
  };

  const canConvert =
    Boolean(organization?.convertToCompleteEnabled) &&
    user?.role === 'admin' &&
    CONVERTIBLE_TABS.includes(tab);
  const pageSessionIds = (surveySessions?.surveySessions || [])
    .map((session) => session?._id)
    .filter(Boolean);
  const allPageSelected =
    pageSessionIds.length > 0 &&
    pageSessionIds.every((sessionId) => selectedIds.includes(sessionId));

  useEffect(() => {
    setSelectedIds([]);
  }, [tab, page, rowsPerPage, filters]);

  const toggleSession = (sessionId) => {
    setSelectedIds((current) =>
      current.includes(sessionId)
        ? current.filter((item) => item !== sessionId)
        : [...current, sessionId],
    );
  };

  const togglePage = () => {
    setSelectedIds((current) => {
      if (allPageSelected) {
        return current.filter((item) => !pageSessionIds.includes(item));
      }
      return [...new Set([...current, ...pageSessionIds])];
    });
  };

  const handleConvert = async () => {
    if (!selectedIds.length || converting) return;
    setConverting(true);
    try {
      const result = await convertSessionsToComplete({
        surveyId: id,
        sessionIds: selectedIds,
      });
      const failures = [];
      if (result?.publisherFailed) {
        failures.push(`${result.publisherFailed} publisher sync failed`);
      }
      if (result?.rewardsFailed) {
        failures.push(`${result.rewardsFailed} Rewards sync failed`);
      }
      setSnackbar({
        open: true,
        severity: failures.length ? 'warning' : 'success',
        msg: `Converted ${result?.converted || 0}, skipped ${
          result?.skipped || 0
        }${failures.length ? `. ${failures.join('. ')}` : ''}`,
      });
      setSelectedIds([]);
      await refetchSurveySessions();
    } catch (error) {
      setSnackbar({
        open: true,
        severity: 'error',
        msg: error?.message || 'Unable to convert sessions',
      });
    } finally {
      setConverting(false);
    }
  };
  // console.log("qualificationTable=>", qualificationTable);
  // console.log({ surveySessions, isError, isLoading });
  // console.log('filters=>', filters);
  // console.log('tempFilters=>', tempFilters);
  // console.log('selectedSuppliers=>', selectedSuppliers);

  return (
    <div className="w-full flex flex-col gap-6">
      {/* Header */}
      <div className="w-full py-4 px-6 bg-white border-b border-[#E0E0E0]">
        <h1 className="text-[#0226BE] text-[24px] font-[500] mb-1">
          Respondent Answers
        </h1>
        <p className="text-[#666] text-[14px] font-[400]">
          View and analyze respondent session data and answers
        </p>
      </div>

      {/* Filters */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-5">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-3 flex-wrap">
            <label className="text-[#666] text-[14px] font-[400]">
              Field Date
            </label>
            <input
              type="date"
              className="border border-[#E0E0E0] h-[40px] px-3 rounded-md text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
              value={tempFilters?.startDate}
              onChange={(e) => {
                setTempFilters((prev) => ({
                  ...prev,
                  startDate: e.target.value,
                }));
              }}
            />
            <span className="text-[#666] text-[14px]">To</span>
            <input
              type="date"
              className="border border-[#E0E0E0] h-[40px] px-3 rounded-md text-[#333] text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
              value={tempFilters?.endDate}
              onChange={(e) => {
                setTempFilters((prev) => ({
                  ...prev,
                  endDate: e.target.value,
                }));
              }}
            />
            <SelectSuppliers
              selected={selectedSuppliers}
              setSelected={setSelectedSuppliers}
              fieldKey="supplier"
              dropdownType="multiple"
              placeholder="Select Suppliers"
              width="200px"
              showFooter={false}
              isSuveySupplier={true}
              surveyId={data?._id}
            />
            <button
              className="border border-[#0226BE] text-[#0226BE] py-2 px-4 text-[14px] font-[500] rounded-md hover:bg-[#0226BE] hover:text-white transition-colors"
              onClick={(e) => {
                setFilters({ ...tempFilters, suppliers: selectedSuppliers });
              }}
            >
              Search
            </button>
            <button
              className="text-[#666] text-[14px] font-[400] hover:text-[#0226BE] transition-colors"
              onClick={() => {
                const start = new Date(
                  new Date().getFullYear(),
                  new Date().getMonth() - 3,
                  new Date().getDate(),
                ).toLocaleDateString('en-CA');

                const end = new Date().toLocaleDateString('en-CA');

                setSelectedSuppliers([]);

                const resetFilters = {
                  startDate: start,
                  endDate: end,
                };

                setTempFilters(resetFilters);

                refetchSurveySessionsData(start, end);
              }}
            >
              Clear filters
            </button>
          </div>
          <div className="flex items-center gap-3">
            {canConvert ? (
              <button
                className={`${
                  selectedIds.length && !converting
                    ? 'bg-[#027A48] cursor-pointer hover:bg-[#02643b]'
                    : 'bg-gray-300 cursor-not-allowed'
                } text-white py-2 px-4 text-[14px] font-[500] rounded-md transition-colors`}
                disabled={!selectedIds.length || converting}
                onClick={() => setShowConvertModal(true)}
              >
                Convert to Complete ({selectedIds.length})
              </button>
            ) : null}
            <button
              className={`${
                surveySessions?.surveySessions?.length
                  ? 'bg-[#0226BE] cursor-pointer hover:bg-[#021ea8]'
                  : 'bg-gray-300 cursor-not-allowed'
              } text-white py-2 px-4 text-[14px] font-[500] rounded-md transition-colors`}
              disabled={!surveySessions?.surveySessions?.length}
              onClick={(e) => DownloadToExcel()}
            >
              Export To Excel
            </button>
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
        <div className="flex items-center gap-6 px-6 py-3 border-b border-[#E0E0E0] bg-gray-50 overflow-x-auto">
          {dummyfilterData?.map((data, ind) => (
            <button
              key={ind}
              className={`text-[14px] font-[500] cursor-pointer transition-colors whitespace-nowrap pb-2 border-b-2 ${
                tab === ind
                  ? 'text-[#0226BE] border-[#0226BE]'
                  : 'text-[#666] border-transparent hover:text-[#0226BE]'
              }`}
              onClick={(e) => {
                setTab(ind);
                setRowsPerPage(50);
                setPage(0);
              }}
            >
              {data?.label}
            </button>
          ))}
        </div>

        {/* Table */}
        <div className="w-full flex flex-col">
          {isLoading ? (
            <TableLoader />
          ) : isError ? (
            <div className="w-full  h-[200px] flex items-center justify-center">
              <h1 className="text-[#666666]">Something went wrong </h1>
            </div>
          ) : (
            <div
              className={`${
                surveySessions?.surveySessions?.length
                  ? 'overflow-x-auto'
                  : 'overflow-x-hidden'
              } w-full  containerScroll`}
            >
              <table
                className="whitespace-nowrap text-left w-full"
                id="table-to-xls-DATA"
              >
                <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                  <tr>
                    {[
                      ...(canConvert ? ['Select'] : []),
                      'Ref ID',
                      ...(surveySessions?.showRid ? ['RID'] : []),
                      'Supplier Account',
                      'Survey No.',
                      'Project No.',
                      'Status',
                      'Client Status',
                      'Browser',
                      'Device Type',
                      'Start Time',
                      'End Time',
                      'Timezone',
                      'Total Time',
                      'CPI',
                    ]?.map((d, idx) => (
                      <th
                        key={idx}
                        className="text-[#666] text-[13px] font-[500] px-4 text-start"
                      >
                        {d === 'Select' ? (
                          <input
                            type="checkbox"
                            aria-label="Select all sessions on this page"
                            checked={allPageSelected}
                            onChange={togglePage}
                          />
                        ) : (
                          d
                        )}
                      </th>
                    ))}
                    {qualificationTable
                      ?.filter((d) => d?.status)
                      ?.map((data) => {
                        return (
                          <td className="text-[#666] text-[14px] font-[600] pl-3 text-start">
                            {data?.question?.questionName}
                          </td>
                        );
                      })}
                  </tr>
                </thead>
                <tbody>
                  {surveySessions?.surveySessions?.length ? (
                    surveySessions?.surveySessions?.map((da, idx) => (
                      <tr
                        key={idx}
                        className="border-b border-[#E0E0E0] transition-colors cursor-pointer hover:bg-blue-50/30"
                      >
                        {canConvert ? (
                          <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                            <input
                              type="checkbox"
                              aria-label={`Select session ${da?.ref_id}`}
                              checked={selectedIds.includes(da?._id)}
                              onChange={() => toggleSession(da?._id)}
                            />
                          </td>
                        ) : null}
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                          {da?.ref_id}
                        </td>
                        {surveySessions?.showRid ? (
                          <td className="px-4 py-4 text-[#333] font-[400] text-[13px] text-start">
                            {da?.rid || '-'}
                          </td>
                        ) : null}
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          <Tooltip
                            content={
                              da?.supplierName || 'Mirats Insights Panel'
                            }
                          >
                            <p className="max-w-[200px] whitespace-nowrap overflow-hidden text-ellipsis">
                              {da?.supplierName || 'Mirats Insights Panel'}
                            </p>
                          </Tooltip>
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {data?.surveyNumber}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {data?.projectNumber}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {getStatsDetail('mirats', da?.mirats_status)} (
                          {da?.mirats_status})
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {getStatsDetail('client', da?.client_status)} (
                          {da?.client_status})
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {da?.sessionTechnicalDetails?.browserName || '-'}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {da?.sessionTechnicalDetails?.os || '-'}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {new Date(
                            da?.survey_start_time,
                          )?.toLocaleDateString() +
                            ' ' +
                            new Date(
                              da?.survey_start_time,
                            )?.toLocaleTimeString()}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {da?.survey_end_time
                            ? new Date(
                                da?.survey_end_time,
                              )?.toLocaleDateString() +
                              ' ' +
                              new Date(
                                da?.survey_end_time,
                              )?.toLocaleTimeString()
                            : '-'}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {da?.geoData?.time_zone?.name || '-'}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {da?.total_survey_time}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {Number(da?.surveyCPI)?.toFixed(2) || 0}
                        </td>

                        {qualificationTable?.map((data, qIdx) => {
                          const response = da?.responses?.find(
                            (res) => res?.question_id === data?._id,
                          );
                          if (typeof response?.user_response == 'string') {
                            return (
                              <td
                                key={qIdx}
                                className="px-4 py-4 text-[#333] font-[400] text-[13px]"
                              >
                                {response?.user_response}
                              </td>
                            );
                          } else {
                            return (
                              <td
                                key={qIdx}
                                className="px-4 py-4 text-[#333] font-[400] text-[13px]"
                              >
                                {response?.user_response?.map((ur, urIdx) => (
                                  <p key={urIdx}>{ur}</p>
                                ))}
                              </td>
                            );
                          }
                        })}
                      </tr>
                    ))
                  ) : (
                    <td colSpan={12}>
                      <div className="py-10">
                        <NoData
                          msg={
                            <div className="flex items-center gap-[10px]">
                              <h1>Try Changing the filters</h1>
                              {/* <button
                    className="py-1 px-4 bg-primary text-[#fff] rounded-md font-[500]"
                    onClick={(e) => console.log("hehe")}
                  >
                    Clear
                  </button> */}
                            </div>
                          }
                        />
                      </div>
                    </td>
                  )}
                </tbody>
              </table>
            </div>
          )}

          <CustomTablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            sx={{ fontSize: '10px' }}
            count={surveySessions?.pagination?.totalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            componentsProps={{
              select: {
                'aria-label': 'rows per page',
              },
              actions: {
                showFirstButton: true,
                showLastButton: true,
              },
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
      <ConfirmationModal
        modalOpen={showConvertModal}
        setModalOpen={setShowConvertModal}
        title={`Convert ${selectedIds.length} session${
          selectedIds.length === 1 ? '' : 's'
        } to Complete?`}
        description="These sessions will count as completes for this survey, including billing. Publisher records are updated, and Mirats Rewards members are credited. Completes can go above the survey target. This cannot be undone from here."
        onSubmit={handleConvert}
      />
    </div>
  );
};

export default RespondentAnswers;
